(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.option-selectors[data-disable-unavailable="true"]';

    const synchronize = (picker) => {
      if (picker.dataset.compatibilitySync === 'running') return;
      picker.dataset.compatibilitySync = 'running';

      const radios = [...picker.querySelectorAll('.opt-btn')];
      const selectedUnavailable = radios.find((radio) => radio.checked && radio.classList.contains('is-unavailable'));

      if (selectedUnavailable) {
        const group = selectedUnavailable.closest('.option-selector');
        const replacement = [...group.querySelectorAll('.opt-btn')].find((radio) => !radio.classList.contains('is-unavailable'));
        const replacementLabel = replacement && group.querySelector(`label[for="${replacement.id}"]`);

        picker.dataset.compatibilitySync = '';
        if (replacementLabel) {
          replacement.disabled = false;
          replacement.setAttribute('aria-disabled', 'false');
          replacementLabel.click();
          const status = picker.querySelector('[data-variant-compatibility-status]');
          if (status) status.textContent = picker.dataset.compatibleChoiceMessage;
        }
        return;
      }

      radios.forEach((radio) => {
        const unavailable = radio.classList.contains('is-unavailable');
        radio.disabled = unavailable;
        radio.setAttribute('aria-disabled', String(unavailable));
      });

      picker.dataset.compatibilitySync = '';
    };

    const initialize = (picker) => {
      if (picker.dataset.compatibilityGuard === 'true') return;
      picker.dataset.compatibilityGuard = 'true';

      new MutationObserver((mutations) => {
        if (mutations.some((mutation) => mutation.type === 'attributes' && mutation.attributeName === 'class')) {
          requestAnimationFrame(() => synchronize(picker));
        }
      }).observe(picker, { attributes: true, attributeFilter: ['class'], subtree: true });

      requestAnimationFrame(() => synchronize(picker));
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll(selector).forEach(initialize);
    };

    initializeAll();

    new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length)) initializeAll();
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
